import 'choerodon-ui/lib/style/index.less';
// style dependencies
import 'choerodon-ui/lib/trigger/style';
import './index.less';
